import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Action from "./components/Action";
import Services from "./components/Services";
import Footer from "./components/Footer";
import WhatsappButton from "./components/WhatsappButton";

function App() {
  return (
    <div className="app-container">
      <Navbar />
      <Hero />
      <About />
      <Action />
      <Services />
      <WhatsappButton />
      <main>
        <Footer />
      </main>
    </div>
  );
}

export default App;
